/*eslint-disable*/
import {
    Row,
    Col,
    ListGroupItem,
    ListGroup,
} from "reactstrap";
import './roadmap.public.scss';

import FeatureRequestCreate from './FeatureCreate.component';
import SingleRoadmapItem from "../../common/roadmap/SingleItem/SingleRoadmapItem";

const FeatureRequests = ({
    allRoadmaps,
    getRoadmapDetails,
    companyID,
    createUpvotes,
    poweredBy,
    openRoadmapDetails,
    authModalToggle,
    tokenExists,
    getUserToken,
    filterRoadmaps,
    companyInfo,
}) => {
    const {
        feature_request_title,
        feature_request_description,
    } = companyInfo;
    const onRoadmapClick = (roadmap) => {
        openRoadmapDetails(roadmap);
    };

    const excludedStatuses = ['trash', 'pending'];

    return (
        <div className="feature-requests">
            <div className="public-content-header">
                <h4 className="public-content-title">{feature_request_title}</h4>
                <p className="public-content-subtitle">{feature_request_description}</p>
            </div>
            <Row className="feature-requests__row">

                <Col md={{ size: 9, order: 1 }} lg={{ size: 9, order: 2 }} className="all-features" xs={{ order: 2 }}>

                    <ListGroup className="feature-requests__list-group">
                        <div className="feature-req-div">
                            {
                                allRoadmaps.map((roadmap, index) => {
                                    // return if roadmap.status !== trash
                                    return (
                                        <>
                                            {
                                                !excludedStatuses.includes(roadmap.status) &&
                                                <SingleRoadmapItem
                                                    onRoadmapClick={onRoadmapClick}
                                                    roadmap={roadmap}
                                                    index={index}
                                                    key={index}
                                                    upvoteHandler={createUpvotes}
                                                    pageType={'public-feature-request'}
                                                />
                                            }
                                        </>
                                    )
                                })
                            }
                            {
                                allRoadmaps.length === 0 && (
                                    <ListGroupItem className="list-roadmap empty">
                                        <div>No roadmaps found.</div>
                                    </ListGroupItem>
                                )
                            }
                        </div>
                    </ListGroup>
                </Col>
                <Col md={{ size: 3, order: 2 }}
                    className="feature-create-public"
                    xs={{
                        order: 1,
                        size: 12,
                    }}>
                    <FeatureRequestCreate
                        getRoadmapDetails={getRoadmapDetails}
                        companyID={companyID}
                        authModalToggle={authModalToggle}
                        tokenExists={tokenExists}
                        getUserToken={getUserToken}
                        filterRoadmaps={filterRoadmaps}
                    />
                </Col>
            </Row>
            <p className="poweredby-link">
                <a href={poweredBy} target="_blank">
                    <svg width="8" height="15" stroke="#000000a2"
                        stroke-width="2" style={{ marginRight: '4px' }}>
                        <path fill="#F9C933" fill-rule="evenodd" stroke="#EE8B00" stroke-width=".8" d="M4.256 5.777h3.65L.716 15.935l2.721-7.927H.14l6.503-10.08-2.387 7.849z"></path>
                    </svg>
                    by ProductLogz
                </a>
            </p>
        </div>
    );
};

export default FeatureRequests;
